/**
 * @file 表单校验
 * @version
 * @author pankzou
 * @date 2022-02-24
 * @lastModified
 * @lastModifiedDate
 */
import * as valid from './validate'

/**
 * IP
 * @param {string} str
 * @returns {Boolean}
 */
export function validateIP(rule, value, callback) {
	if (!valid.isIP(value)) {
		callback(new Error('IP格式错误！'))
	} else {
		callback()
	}
}

/**
 * 校验手机号
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export function validateMobile(rule, value, callback) {
	if (!value) {
		return callback()
	}

	if (!valid.isMobile(value)) {
		callback(new Error('手机号格式错误！'))
	} else {
		callback()
	}
}

/**
 * 密码
 * @param {string} str
 * @returns {Boolean}
 */
export function validatePassword(rule, value, callback) {
	if (!valid.isPassword(value)) {
		callback(new Error('密码为6-18位，包含数字、字母！'))
	} else {
		callback()
	}
}

/**
 * 强密码（至少包含一个大写字母、一个小写字母、一个特殊字符、一个数字）
 * @param {string} str
 * @returns {Boolean}
 */
export function validateStrongPassword(rule, value, callback) {
	if (!valid.isStrongPassword(value)) {
		callback(new Error('密码为6-18字符，至少包含一个大小写字母、数字和特殊符号！'))
	} else {
		callback()
	}
}

/**
 * 身份证校验
 * @param rule
 * @param value
 * @param callback
 */
export function validateIdCard(rule, value, callback) {
	if (value) {
		if (!valid.isIdCard(value)) {
			callback(new Error('身份证号码格式不正确！'))
		} else {
			callback()
		}
	} else {
		callback()
	}
}

/**
 * 统一社会信用代码校验
 * @param rule
 * @param value
 * @param callback
 */
export function validateUniscid(rule, value, callback) {
	if (value) {
		if (!valid.isUniscid(value)) {
			callback(new Error('统一社会信用代码格式不正确！'))
		} else {
			callback()
		}
	} else {
		callback()
	}
}

/**
 * xss 攻击校验
 * @param {string} str
 * @returns {Boolean}
 */
export function validateXss(rule, value, callback) {
	if (!valid.isXss(value)) {
		callback(new Error('不能同时包含<>！'))
	} else {
		callback()
	}
}

/**
 * 特殊字符及空格
 * @param {string} str
 * @returns {Boolean}
 */
export function validateSpclChar(rule, value, callback) {
	if (!valid.isSpclChar(value)) {
		callback(new Error('不能包含特殊字符、空格！'))
	} else {
		callback()
	}
}

/**
 * 邮政编码校验
 * @param {string} str
 * @returns {Boolean}
 */
export function validateZipCode(rule, value, callback) {
	if (!valid.isZipCode(value)) {
		callback(new Error('请输入正确的邮政编码！'))
	} else {
		callback()
	}
}

/**
 * 邮箱校验
 * @param {string} str
 * @returns {Boolean}
 */
export function validateEmail(rule, value, callback) {
	if (!valid.isEmail(value)) {
		callback(new Error('请输入正确的邮箱！'))
	} else {
		callback()
	}
}

/**
 * 大于0的正整数校验
 * @param rule
 * @param value
 * @param callback
 */
export function validatePositiveInteger(rule, value, callback) {
	if (!valid.isPositiveInteger(value)) {
		callback(new Error('请输入大于0的正整数！'))
	} else {
		callback()
	}
}

/**
 * 大于0且最多保留2位小数的数字
 * @param rule
 * @param value
 * @param callback
 */
export function validateTwoDecimalNumber(rule, value, callback) {
	if (!valid.isTwoDecimalNumber(value)) {
		callback(new Error('请输入大于0且最多保留2位小数的数字！'))
	} else {
		callback()
	}
}

/**
 * 校验数值类型
 * @param rule
 * @param value
 * @param callback
 */
export function validateIsNumber(rule, value, callback) {
	if (!valid.isNumber(value)) {
		callback(new Error('请输入数值类型且最多保留6位小数！'))
	} else {
		callback()
	}
}
